import { Component, inject } from '@angular/core';
import { AuthService } from '@services/auth.service';
import { SkeletonModule } from 'primeng/skeleton';
@Component({
    selector: 'home',
    imports: [SkeletonModule],
    templateUrl: './home.component.html',
    styles: ``
})
export class HomeComponent {
    currentUser = inject(AuthService).currentUser();
}
